import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  type: "",
  data: {},
  toast: {},
  loadings: {},
  show: false,
  refresh: true,
}
const other = createSlice({
  name: "other",
  initialState,
  extraReducers: (builder) => {
    // handle reatrieve all
    builder.addCase("retrieveAll/pending", (state) => {
      state.loadings.retrieveAll = true
    })
    builder.addCase("retrieveAll/fulfilled", (state) => {
      delete state?.loadings?.retrieveAll
    })
    builder.addCase("retrieveAll/rejected", (state) => {
      delete state?.loadings?.retrieveAll
    })

    // handle reatrieve single
    builder.addCase("retrieveSingle/pending", (state) => {
      state.loadings.retrieveSingle = true
    })
    builder.addCase("retrieveSingle/fulfilled", (state) => {
      delete state?.loadings?.retrieveSingle
    })
    builder.addCase("retrieveSingle/rejected", (state) => {
      delete state?.loadings?.retrieveSingle
    })

    // handle create
    builder.addCase("create/pending", (state) => {
      state.loadings.create = true
    })
    builder.addCase("create/fulfilled", (state) => {
      delete state?.loadings?.create
    })
    builder.addCase("create/rejected", (state) => {
      delete state?.loadings?.create
    })

    // handle update
    builder.addCase("update/pending", (state) => {
      state.loadings.update = true
    })
    builder.addCase("update/fulfilled", (state) => {
      delete state?.loadings?.update
    })
    builder.addCase("update/rejected", (state) => {
      delete state?.loadings?.update
    })

    // handle delete
    builder.addCase("delete/pending", (state) => {
      state.loadings.delete = true
    })
    builder.addCase("delete/fulfilled", (state) => {
      delete state?.loadings?.delete
    })
    builder.addCase("delete/rejected", (state) => {
      delete state?.loadings?.delete
    })

  },
  reducers: {
    // Dialogs
    showDialogWithData: (state, { payload }) => {

      state.show = true
      state.type = payload?.type
      state.data = { ...payload?.data }
    },
    showDialog: (state, { payload }) => {
      state.show = true
      state.type = payload
    },
    hideDialog: (state) => {
      state.type = ""
      state.data = {}
      state.show = false
      state.categoryId = null
    },

    // Toaster
    toastError: (state, { payload }) => {
      state.toast.show = true
      state.toast.msg = payload
      state.toast.severity = "error"
    },
    toastSuccess: (state, { payload }) => {
      state.toast.show = true
      state.toast.msg = payload
      state.toast.severity = "success"
    },
    toastHide: (state) => {
      delete state?.toast?.show
    },

    refresher: (state) => {
      state.refresh = !state.refresh
    }
  },
})

export const {
  toastSuccess, toastHide, showDialogWithData,
  refresher, showDialog, hideDialog, toastError,
} = other.actions
export default other.reducer